import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';
import { ConfigurationServices } from '../../../configuration/services';

/**
 * Generated class for the DeliveryTakeawaySalesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-delivery-takeaway-sales',
  templateUrl: 'delivery-takeaway-sales.html',
})
export class DeliveryTakeawaySalesPage {

  public chartData: any;
  public chartLabels: any;
  public chartCheck: any;
  sales_delivery = 0;
  total_avg = 0;
  //datatable
  rows = [];
  temp = [];
  columns = [
    { prop: 'date', name: this.translate.instant('general-fecha-elaboracion') },
    { prop: 'delivery', name: this.translate.instant('general-delivery') },
    { prop: 'total', name: this.translate.instant('general-total') + " (" + this.globals.currency_symbol + ")" },
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController,
    public configurationServices: ConfigurationServices) {
    this.getAnalyticsData();
  }


  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {
    this.chartCheck = false;
    //reset
    this.sales_delivery = 0;

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'))
      .set('currency_lang', this.globals.currency_lang);


    this.http.post(this.globals.analytics_path + 'analytics/delivery_total', params, {})
      .subscribe(async response => {
        //chart
        this.sales_delivery = response['sales'];
        this.total_avg = response['total_avg'];

        this.chartLabels = response['daily_data']['labels'];

        this.chartData = {
          labels: this.chartLabels,
          datasets: response['daily_data']['datasets']
        };
        //list
        this.rows = response['list'];
        this.temp = response['list'];

        this.chartCheck = true;
      });

  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.date.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  export() {
    const params = new HttpParams()
      .set('data', JSON.stringify(this.rows))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({ 'Sales': this.sales_delivery, 'Total Avg': this.total_avg }));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/delivery-takeaway-sales/delivery-takeaway-sales.ts